<template>
  <nut-row class="loading" v-if="fail">
    <span>{{ loginError || '登录失败，请重新打开页面重试' }}</span>
  </nut-row>
  <nut-row class="loading" v-else>
    <h3>登录中...</h3>
    <nut-icon name="loading" size="large"></nut-icon>
  </nut-row>
</template>


<script>
import {Dialog, Toast} from '@nutui/nutui';
import api from "@/api";
import {mapMutations} from "vuex";
import md5 from 'js-md5'
import {readEntryToken} from '@/utils/entryToken'
// import Vconsole from 'vconsole'

export default {
  name: "LoginView",
  data() {
    return {
      fail: false,
      loginError: '',
      wechatLoginInProgress: false,
      loginDisposed: false,
      accountLoginType: false,
      account: '',
      password: '',
      captcha: '',
      fastLoginType: false,
      isWxEnv: false,
      isAlipayEnv: false,
      isZlb: false,
      captchaToken: '376233414898836402b069bdefault',
      wxBindToken: null,
      loginChecker: null,
      timeouter: null,
    }
  },
  watch: {
    accountLoginType(b) {
      if (!b) {
        return
      }
      this.refreshCaptcha();
    }
  },
  methods: {
    ...mapMutations(['updateUser', 'updateEnv']),
    wxLogin() {
      if (this.loginDisposed || this.wechatLoginInProgress) {
        return;
      }
      this.wechatLoginInProgress = true;
      Toast.loading('请稍等...', {
        duration: 5000
      });
      let url = this.$route.query.redirect;
      let code = this.$route.query.code;
      if (code) {
        api.wechatCodeLogin(code).then(ret => {
          Toast.hide();
          if (ret.action === 0) {
            this.accountLoginType = true;
            this.wxBindToken = ret.token;
            Toast.fail("您未绑定账号，请使用账号密码登录");
            this.refreshCaptcha();
          } else {
            this.setAccessToken(ret.accessToken);
            this.loadUserInfo();
          }
        }).catch(() => {
          Toast.hide()
          this.wechatLoginInProgress = false;
          this.fail = true;
        })
      } else {
        api.getWechatRedirectUrl(url).then(ret => {
          if (!this.loginDisposed) {
            window.location.href = ret;
          }
        }).catch(() => {
          Toast.hide();
          this.wechatLoginInProgress = false;
          this.fail = true;
          this.loginError = '微信静默登录失败，请重新打开页面重试';
          Toast.fail('微信授权暂时不可用，请重试');
        })
      }
    },
    async alipayLogin() {
      Toast.loading('请稍等...', {duration: 15000});
      try {
        // 沿用历史支付宝 H5 登录协议，不走微信授权。
        // eslint-disable-next-line no-undef
        if (typeof ap === 'undefined' || typeof ap.getAuthCode !== 'function') {
          throw new Error('支付宝登录组件未加载，请重新打开页面');
        }
        const code = await Promise.race([
          new Promise((resolve, reject) => {
            // eslint-disable-next-line no-undef
            ap.getAuthCode({appId: '2021004163601717', scopes: ['auth_user']}, result => {
              if (result && result.authCode) {
                resolve(result.authCode);
              } else {
                reject(new Error('支付宝授权未完成，请返回小程序重试'));
              }
            });
          }),
          this.timeout(15000)
        ]);
        if (this.loginDisposed) return;
        const result = await api.alipayCodeLogin(code);
        if (this.loginDisposed) return;
        this.setAccessToken(result.accessToken);
        await this.loadUserInfo();
      } catch (error) {
        this.loginError = '支付宝登录未完成，请返回小程序重新打开页面';
        this.fail = true;
      } finally {
        Toast.hide();
      }
    },
    zlbLogin(ticket) {
      Toast.loading('请稍等...', {
        duration: 5000
      });
      api.zlbLoginByTicket(ticket)
          .then(ret => {
            Toast.hide();
            this.setAccessToken(ret.accessToken);
            this.loadUserInfo();
          }).catch(() => {
        Toast.hide()
        this.fail = true;
      })
    },
    passwordLogin() {
      if (!this.account || !this.password || !this.captcha) {
        Toast.warn('账号、密码、验证码都是必填项');
        return
      }
      Toast.loading('请稍等...');
      api.login({
        phone: this.account,
        password: md5(this.password),
        captcha: this.captcha,
        token: this.captchaToken,
        channel: 1
      }).then(ret => {
        Toast.hide();
        this.setAccessToken(ret.accessToken);
        if (this.wxBindToken) {
          Dialog({
            title: '是否绑定该账号',
            content: '绑定后再次打开可免密登录',
            onCancel: () => {
              this.loadUserInfo();
            },
            onOk: () => {
              api.bindWechat(this.wxBindToken).then(() => {
                Toast.success("绑定成功!");
              });
              this.loadUserInfo();
            }
          });
        } else {
          this.loadUserInfo();
        }
      })
    },
    setAccessToken(accessToken) {
      this.$store.commit('updateAccessToken', accessToken);
      // localStorage.setItem('xfbm_access_token', accessToken);
    },
    loadUserInfo() {
      return api.getUserInfo().then(userInfo => {
        document.title = '消防便民服务';
        this.updateUser(userInfo);
        if (this.isWxEnv) {
          this.updateEnv('wechat')
        } else if (this.isAlipayEnv) {
          this.updateEnv('alipay');
        } else if (this.isZlb) {
          this.updateEnv('zlb')
        } else {
          this.updateEnv('h5');
        }
        // 取到原页面路径
        let url = this.$route.query.redirect;
        console.log('跳转', url)
        this.timeouter = setTimeout(() => {
          console.log('强制跳转')
          this.$router.replace('/')
        }, 1000)
        // 跳转回原页面
        this.$router.replace({
          path: url ? url : '/'
        });
      })
    },
    timeout(ms) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          reject(new Error("Timeout after " + ms + " ms"));
        }, ms);
      });
    }
  },
  beforeUnmount() {
    this.loginDisposed = true;
    if (this.loginChecker) {
      clearTimeout(this.loginChecker)
    }
    if (this.timeouter) {
      clearTimeout(this.timeouter)
    }
  },
  async mounted() {
    // let vConsole = new Vconsole()
    // console.log('vconsole', vConsole != null)
    document.title = '消防便民服务';
    //检测快捷登录码
    const entryToken = this.$route.query.accessToken || readEntryToken(window.location.href);
    if (entryToken) {
      Toast.loading('请稍等...', {
        duration: 500
      });
      this.fastLoginType = true;
      this.setAccessToken(entryToken);
      this.$router.push("/");
      return;
    }
    // 微信优先，不能因加载了浙里办 SDK 就进入浙里办登录。
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (/micromessenger/i.test(userAgent)) {
      this.isWxEnv = true;
      this.wxLogin();
      return;
    }
    if (/alipayclient/i.test(userAgent)) {
      this.isAlipayEnv = true;
      await this.alipayLogin();
      return;
    }
    try {
      // eslint-disable-next-line no-undef
      if (typeof ZWJSBridge !== 'undefined' && ZWJSBridge.ssoTicket) {
        this.isZlb = true;
        const result = await Promise.race([
          // eslint-disable-next-line no-undef
          ZWJSBridge.ssoTicket({}),
          this.timeout(2000)
        ]);
        if (result && result.result === true && result.ticketId) {
          this.zlbLogin(result.ticketId);
          return;
        }
      }
      this.loginError = /alipayclient/i.test(userAgent)
          ? '小程序登录信息缺失或已失效，请返回小程序重新登录后打开页面'
          : '请在微信或浙里办中打开页面';
    } catch (e) {
      this.loginError = '未能识别登录环境，请在微信或浙里办中重新打开页面';
    }
    this.fail = true;
  }
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30%;
}

.loginBtn {
  font-size: $baseFontSize;
}

.login-input {
  border: 1px solid lightgray;
  width: 80%;
  margin-left: 10%;
  border-radius: 20px;
  padding: 5px 10px;
  margin-bottom: 10px;
  font-size: $baseFontSize;
}

.login-input-captcha {
  margin-left: auto;
}

.nut-row {
  overflow: hidden;

  &:not(:last-child) .nut-col {
    margin-bottom: 15px;
  }

  margin-bottom: 15px;
}

.flex-content {
  line-height: 40px;
  text-align: center;
  border: 0;
  font-size: $baseFontSize;

  p {
    padding: 0;
    margin: 0;
    line-height: 25px;
    font-size: $baseFontSize;
    color: #005FF5;
  }
}
</style>